import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { refreshToken } from './authSlice';

interface APIResponse<T> {
  error?: string;
  message?: string;
  data?: T;
}

async function http<T>(path: string, authToken: string, dispatch: ThunkDispatch<any, any, AnyAction>, config: RequestInit): Promise<APIResponse<T>> {
  const request = new Request(path, {
    credentials: 'include',
    headers: new Headers({
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    }),
    ...config,
  });
  const response = await fetch(request)
  if(!response.ok) {
    switch (response.status) {
      case 401:
        console.log('401 unauthorized returned, fetching updated token.')
        dispatch(refreshToken());
        break;
      case 403:
        console.log('403 forbidden returned, fetching updated token.')
        dispatch(refreshToken());
        break;
      default:
        console.log('Unhandled error code in auth fetch:', response.status);
    }
    throw new Error(response.statusText)
  }
  // may error if there is no body, return empty object
  const typedResponse = await response.json().catch(() => ({})) as APIResponse<T>;
  if (typedResponse.error) {
    throw new Error(typedResponse.error);
  }
  return typedResponse
}

export async function get<T>(path: string, authToken: string, dispatch: ThunkDispatch<any, any, AnyAction>, config?: RequestInit): Promise<APIResponse<T>> {
  const init = {method: 'get', ...config}
  return await http<T>(path, authToken, dispatch, init)
}

export async function post<T, U>(path: string, body: T, authToken: string, dispatch: ThunkDispatch<any, any, AnyAction>, config?: RequestInit): Promise<APIResponse<U>> {
  const init = {method: 'post', body: JSON.stringify(body), ...config}
  return await http<U>(path, authToken, dispatch, init)
}

export async function put<T, U>(path: string, body: T, authToken: string, dispatch: ThunkDispatch<any, any, AnyAction>, config?: RequestInit): Promise<APIResponse<U>> {
  const init = {method: 'put', body: JSON.stringify(body), ...config}
  return await http<U>(path, authToken, dispatch, init)
}
